import { useCallback } from 'react';
import { useTranslatedMessages } from '../../../hooks/useTranslatedMessages';
import { LANGUAGES } from '../../../constants/appConstants';
import customersByLang from '../../../locales/customers.json';
import { mapAmlScreeningError } from './amlScreeningConstants';

export const useAmlScreeningErrorMessage = () => {
  const { customers: c, language } = useTranslatedMessages();
  const labels = c?.amlScreening?.errors ?? customersByLang[language ?? LANGUAGES.EN]?.amlScreening?.errors;

  return useCallback((error) => mapAmlScreeningError(error, labels), [labels]);
};
